<template>
    END!

    <p>selected IndicatorId: {{ selectedIndicatorId }} ( {{ arrindicators[selectedIndicatorId-1].indicatorStringAbbrv }} )</p>
    <p>selected ChartType: {{ chartType }}</p>
    <p>Groups: </p><pre>{{ groups }}</pre>

    <a @click="restart">Restart</a>
</template>

<script type="module">

</script>

<script setup>

import { storeToRefs } from 'pinia'
import { useVisualizationsStore } from '../../stores/vis_store'


const {  restart } = useVisualizationsStore()
const { selectedIndicatorId , chartType, arrindicators, groups} = storeToRefs(useVisualizationsStore())


</script>